import { Invoice, invoiceDB } from '../../models/invoice'
import { toRaw, ref } from 'vue'
import { getPdf } from '../../services/utils'
import {
  createbilling,
  getAllInvoices,
  getInvoiceDetail,
  getPaymentMethods,
  bulkAdd,
  checkInvoice,
  sendInvoice,
  deletebilling,
  moveInvoice,
  previewMoveInvoice,
  updatebilling,
  getCategories,
  sendWhatsApp,
  createCreditNote,
} from '../../services/invoice'
const globalData = ref(null)
const currentLoadedData = ref(null)
export const years = ref<any[]>([])
export const status = ref<any[]>([])
// Simulate API calls

export type Pagination = {
  page: number
  perPage: number
  total: number
}

export type Sorting = {
  sortBy: keyof Invoice | undefined
  sortingOrder: 'asc' | 'desc' | null
}

export type Filters = {
  isActive: boolean
  search: string
  month: string
  documentType: string
  year: number
  status: string
  ambiente: number
  assignment?: string | null
}

const getSortItem = (obj: any, sortBy: string) => {
  return obj[sortBy]
}

function lineMatchesAssignment(lines: any[] | undefined, assignment: string) {
  const rows = lines || []
  if (assignment === 'none') {
    return rows.some((line) => !line.budgetItemId && !line.fundId)
  }
  if (assignment.startsWith('b-')) {
    return rows.some((line) => `b-${line.budgetItemId}` === assignment)
  }
  if (assignment.startsWith('f-')) {
    return rows.some((line) => `f-${line.fundId}` === assignment)
  }
  if (assignment.startsWith('c-')) {
    return rows.some((line) => `c-${line.category ?? line.invoiceProductCategory?.id}` === assignment)
  }
  return true
}

export const getInvoices = async (filters: Partial<Filters & Pagination & Sorting>, loadOtherIncomings = false) => {
  //let invoicesData
  let filteredInvoices
  //it will load invoices or other incomings documents
  if (currentLoadedData.value !== loadOtherIncomings) globalData.value = null
  currentLoadedData.value = loadOtherIncomings as any
  if (!globalData.value) {
    const { data } = await getAllInvoices(loadOtherIncomings)
    globalData.value = data
    filteredInvoices = data
    years.value = [
      ...new Set(
        filteredInvoices.map((p: any) => {
          return parseInt(p.date.split('-')[0])
        }),
      ),
    ]

    status.value = [
      ...new Set(
        filteredInvoices.map((p: any) => {
          return p.status
        }),
      ),
    ]
  } else {
    filteredInvoices = globalData.value
  }

  const { isActive, search, sortBy, sortingOrder, month, documentType, year, status: statusSearch, ambiente, assignment } =
    filters

  if (year) {
    filteredInvoices = filteredInvoices.filter((invoice: any) => {
      const splitDate = invoice.date.split('-')
      return splitDate[0] === `${year}`
    })
  }

  if (month && month !== '-1') {
    filteredInvoices = filteredInvoices.filter((invoice: any) => {
      const splitDate = invoice.date.split('-')
      return splitDate[1] === month
    })
  }
  if (statusSearch) {
    filteredInvoices = filteredInvoices.filter((invoice: any) => {
      return invoice.status === statusSearch
    })
  }
  if (ambiente) {
    filteredInvoices = filteredInvoices.filter((invoice: any) => {
      return invoice.ambiente == ambiente
    })
  }

  if (!loadOtherIncomings && search) {
    filteredInvoices = filteredInvoices.filter(
      (invoice: Invoice) =>
        invoice.client!.fullname.toLowerCase().includes(search.toLowerCase()) ||
        invoice.code?.includes(search.toLowerCase()) ||
        invoice.number?.toString().includes(search.toLowerCase()) ||
        JSON.stringify(invoice.additionalFields).toLowerCase().includes(search.toLowerCase()),
    )
  } else if (loadOtherIncomings && search) {
    const searchLower = search.toLowerCase()

    filteredInvoices = filteredInvoices.filter((invoice: Invoice) => {
      const matchesAdditional = JSON.stringify(invoice.additionalFields || {})
        .toLowerCase()
        .includes(searchLower)

      const matchesTotal = JSON.stringify(invoice.total).toLowerCase().includes(searchLower)

      const matchesProducts = invoice.productsList?.some((product: any) => {
        const categoryMatch = product.invoiceProductCategory?.label?.toLowerCase().includes(searchLower)

        const detailMatch = product.detail?.toLowerCase().includes(searchLower)

        return detailMatch || categoryMatch
      })
      return matchesAdditional || matchesProducts || matchesTotal
    })
  }

  if (loadOtherIncomings && assignment) {
    filteredInvoices = filteredInvoices.filter((invoice: Invoice) =>
      lineMatchesAssignment(invoice.productsList, assignment),
    )
  }

  filteredInvoices = filteredInvoices.map((invoice: Invoice) => ({ ...invoice }))

  if (sortBy && sortingOrder) {
    filteredInvoices = filteredInvoices.sort((a: any, b: any) => {
      const first = getSortItem(a, sortBy)
      const second = getSortItem(b, sortBy)
      if (first > second) {
        return sortingOrder === 'asc' ? 1 : -1
      }
      if (first < second) {
        return sortingOrder === 'asc' ? -1 : 1
      }
      return 0
    })
  }

  const { page = 1, perPage = 10 } = filters || {}
  return {
    data: filteredInvoices.slice((page - 1) * perPage, page * perPage),
    pagination: {
      page,
      perPage,
      total: filteredInvoices.length,
    },
  }
}

export const addInvoice = async (invoice2: Invoice) => {
  try {
    invoice2.products = toRaw(invoice2.products)
    if (!invoice2.isManual) {
      invoice2.client = toRaw(invoice2.client)
      invoice2.client!.identificationType = toRaw(invoice2.client!.identificationType)
      invoice2.paymentMethod = toRaw(invoice2.paymentMethod)
    }
    invoice2.additionalFields = toRaw(invoice2.additionalFields)

    const resp = await createbilling(invoice2)
    globalData.value = null
    if (resp.status === 200 && resp.data) {
      const { estado, mensajes } = resp.data
      return { estado, mensajes }
    }
  } catch (e) {
    console.error(e)
    throw e
  }
}

export const updateInvoice = async (invoice: Invoice) => {
  try {
    //solo para registro de egresos
    invoice.additionalFields = toRaw(invoice.additionalFields)
    invoice.paymentMethod = toRaw(invoice.paymentMethod)
    const resp = await updatebilling(invoice)
    globalData.value = null
    if (resp.status === 200 && resp.data) {
      const { estado, mensajes } = resp.data
      return { estado, mensajes }
    }
  } catch (e) {
    throw e
  }
}

export const previewInvoiceMove = async (id: string, workspaceId: number) => {
  return previewMoveInvoice(id, workspaceId)
}

export const moveInvoiceWorkspace = async (
  id: string,
  workspaceId: number,
  choices: {
    accountId?: number | null
    categoryId?: number | null
    budgetItemId?: number | null
    fundId?: number | null
  },
) => {
  await moveInvoice(id, workspaceId, choices)
  globalData.value = null
}

export const removeInvoice = async (invoice: Invoice) => {
  try {
    await deletebilling(invoice.id!)
    globalData.value = null
  } catch (e) {
    throw e
  }
}
export const getMaxId = async () => {
  try {
    const invoice = await invoiceDB.invoices.orderBy('id').last()
    return invoice?.id
  } catch (e) {
    throw e
  }
}
export const donwloadPDF = async (invoice2: Invoice) => {
  try {
    await getPdf(invoice2)
  } catch (e) {
    throw e
  }
}

export const getDetail = async (id: string) => {
  try {
    const { data } = await getInvoiceDetail(id)
    return data
  } catch (e) {
    throw e
  }
}

export const getPaymentMethodsAPI = async () => {
  try {
    const { data } = await getPaymentMethods()
    return data
  } catch (e) {
    throw e
  }
}

export const bulkAddInvoices = async (invoices: Invoice[]) => {
  try {
    const resp = await bulkAdd(invoices)
    globalData.value = null
    return true
  } catch (e) {
    console.error(e)
    throw e
  }
}

export const validateInvoice = async (id: string) => {
  try {
    await checkInvoice(id)
    globalData.value = null
    return true
  } catch (e) {
    console.error(e)
    throw e
  }
}

export const sendInvoiceAPI = async (id: string) => {
  try {
    await sendInvoice(id)
    globalData.value = null
    return true
  } catch (e) {
    console.error(e)
    throw e
  }
}

export const getAllCategories = async () => {
  try {
    const { data } = await getCategories('I')
    return data
  } catch (e) {
    console.error(e)
    throw e
  }
}
export const cleanInvoices = async () => {
  try {
    globalData.value = null
    return true
  } catch (e) {
    console.error(e)
    throw e
  }
}

export const sendInvoiceWhatsApp = async (id: string) => {
  try {
    await sendWhatsApp(id)
    globalData.value = null
    return true
  } catch (e) {
    console.error(e)
    throw e
  }
}

export const addCreditNote = async (data: any) => {
  try {
    const resp = await createCreditNote(data)
    globalData.value = null
    if (resp.status === 200 && resp.data) {
      const { estado, mensajes } = resp.data
      return { estado, mensajes }
    }
  } catch (e) {
    console.error(e)
    throw e
  }
}
